import { makeStyles, css } from '@conexasaude/conexa-hero'
import { captionColors } from './constants'

const useStyles = makeStyles<{
  size: string
}>({
  container: theme => css`
    display: flex;
    flex-direction: column;
    margin: ${theme.spacing.xs} 0;

    title {
      margin-bottom: ${theme.spacing.xxs};
    }
  `,

  caption: (theme, { size }) => css`
    color: ${captionColors[size]};
    margin: 0 0 ${theme.spacing.xxs} 0;
  `,
})

export default useStyles
